import React from 'react';
import { ListRow } from '../../../../../../../../../../components';
import type { TypographyProps } from '@mui/material';
import { Box, Typography } from '@mui/material';

type CompareBatchTableInnerRowProps = {
  fieldName: string;
  mutationValue?: React.ReactNode;
  insurerValue: React.ReactNode;
  valueTextColor?: TypographyProps['color'];
  isRowHeaders?: boolean;
  customStyling?: any;
};

export const CompareBatchTableInnerRow = ({
  fieldName,
  mutationValue,
  insurerValue,
  valueTextColor,
  isRowHeaders = false,
  customStyling,
}: CompareBatchTableInnerRowProps) => {
  const variant = isRowHeaders ? 'h6' : undefined;
  return (
    <ListRow innerRow customStyling={customStyling}>
      <Box width={'100%'} display={'flex'} alignItems={'center'} gap={2}>
        <Box textAlign={'left'} minWidth={200}>
          <Typography variant={variant} fontWeight={isRowHeaders ? undefined : 'bold'}>
            {fieldName}
          </Typography>
        </Box>

        <Box display={'flex'} gap={3}>
          <Typography variant={variant} color={valueTextColor} minWidth={200}>
            {mutationValue}
          </Typography>

          <Typography variant={variant} color={valueTextColor}>
            {insurerValue}
          </Typography>
        </Box>
      </Box>
    </ListRow>
  );
};
